import { useMemoizedFn, useMountedPromiseFn, useListState } from 'shared/hooks'
import { services } from 'core/nft/data-access'
import { NftItem } from '../models'

export const useNft = () => {
    const [list, setList] = useListState<NftItem>()

    const getListApi = useMountedPromiseFn(services.getList)
    const getList = useMemoizedFn((account: string) => {
        setList({ loading: true })
        return getListApi(account)
            .then(list => {
                setList({ loading: false, list })
                return list
            })
            .catch(err => {
                setList({ loading: false })
                return Promise.reject(err)
            })
    })

    return {
        ...list,
        methods: { getList }
    }
}
